export const NUMBER_OF_KEYS_MAP = {
  ONE: '1',
  TWO: '2',
  TWO_PLUS: '2+',
};

export const mapNumberOfKeys = (value) => {
  if (value === null || value === undefined) return null;
  return NUMBER_OF_KEYS_MAP[value] ?? 'Not defined';
};
